import HistoryManager from "@utils/HistoryManager";

const open = (titleId, page) => {
  HistoryManager.pushState(titleId, page);
};

export default {
  open,
};
